import { AbstractControl } from '@angular/forms';

const controls: Map<AbstractControl, number> = new Map();
let id = 0; // Start with ID 1

/**
 * Generates a unique ID for a form control in a reactive form.
 * I saw some forms they are created without the formGroup directive, and we can't find the key name of the control.
 * So we generate a unique ID for the control and use it as the key name.
 * @param control
 */
export function* generateControlId(control?: AbstractControl): Generator<number> {
    if (!control) {
        return 0;
    }

    if (controls.has(control)) {
        yield controls.get(control) ?? 0;
    }

    if (!controls.has(control)) {
        id++;
        controls.set(control, id);
        yield controls.get(control) ?? 0;
    }
}
